import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { Button } from '~/components/Atoms/Button'
import { Menu } from '~/components/Organisms/Menu/Menu'

import NotFoundIcon from '~/assets/notFound.svg?react'
import { useUser } from '~/lib/auth'

export function NotFound() {
  const theme = useTheme()
  const user = useUser()
  const { t } = useTranslation()
  const Container = ({ children }: { children: React.ReactNode }) => {
    if (user?.data) {
      return <Menu>{children}</Menu>
    }
    return <Box display="flex">{children}</Box>
  }
  return (
    <Container>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        width="100%"
        gap={theme.spacing['5XL']}
        bgcolor={theme.palette.background.page}
        minHeight={'100vh'}
      >
        <NotFoundIcon />
        <Typography variant="display-bold" color={theme.palette.primary.main}>
          404
        </Typography>
        <Typography variant="h2">{t('notFoundTitle')}</Typography>
        <Typography variant="body">{t('notFoundDescription')}</Typography>
        <Typography variant="body">{t('notFoundError')}</Typography>
        <Box display="flex" alignItems="center" justifyContent="center" gap={theme.spacing['5XL']}>
          <Link to="/">
            <Button startIcon={<HomeOutlinedIcon />} variant="contained" label={t('goToHome')} />
          </Link>
          <Button
            onClick={() => {
              location.href = 'mailTo:support@moodwork.com'
            }}
            variant="outlined"
            label={t('goToSupport')}
          />
        </Box>
      </Box>
    </Container>
  )
}
